module.exports = __webpack_public_path__ + "static/media/check-please-book1-hockey.4bc43844.jpg";